import React from 'react';

interface ResizableThProps {
  width: number;
  onResizeStart: (e: React.MouseEvent) => void;
  align?: 'left' | 'right' | 'center';
  children: React.ReactNode;
  className?: string;
}

const alignClass = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
};

const ResizableTh: React.FC<ResizableThProps> = ({
  width,
  onResizeStart,
  align = 'left',
  children,
  className = '',
}) => {
  return (
    <th
      style={{ width, minWidth: width, maxWidth: width }}
      className={`relative px-2 py-1.5 text-[11px] font-medium text-gray-500 uppercase tracking-wider select-none ${alignClass[align]} ${className}`}
    >
      <span className="block truncate pr-2">{children}</span>
      <span
        role="separator"
        aria-orientation="vertical"
        onMouseDown={onResizeStart}
        className="absolute top-0 right-0 h-full w-1.5 cursor-col-resize hover:bg-indigo-400/50 active:bg-indigo-500/60"
        title="Arrastrar para ajustar ancho"
      />
    </th>
  );
};

export default ResizableTh;
